var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsdSymbolR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 10,
  viewBox: "0 0 10 10",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.6 2.7C7.5 1.6 6.4 1.1 5 1.1 3.5 1.1 2.4 1.8 2.4 2.9c0 2.2 5.3 1.4 5.3 4.1 0 1.2-1.1 1.9-2.7 1.9-1.6 0-2.7-.7-2.8-1.9M5 0v10",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.1
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsdSymbolR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/usd-symbol-r.53fa3c59750c2190f187257be4a76e48.svg";